import { Component, ElementRef, Input, Output, ViewChild, AfterViewInit, EventEmitter } from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
    selector: 'app-highcharts',
    template: '<div #container class="hc-container"></div>',
    styles: [`
		:host {
            position: relative;
			display: flex;
			width: 100%;
			height: 100%;
		}
		
        .hc-container {
            position: absolute;
            height: 100%;
            width: 100%;
        }
	`],
    standalone: true
})
export class HighchartsComponent implements AfterViewInit {
	chart: any;
	chartData: any;
	color: string;
	title: string;

	@Input('sort_data') sort_data: boolean = true;
	@Input('tooltip_title') tooltip_title: string;
	@Input('subtitle') subtitle: string;
	@Input('show_title') show_title: boolean = true;
	@Input('y_text') y_text: string = '';
	@Input('x_text') x_text: string = '';
	@Input('formatter_function') formatter_function: Function;
	@Input('type') type: string = 'column';
	@Input('colors') colors: string[] = [];
	@Input('plotOptons') plotOptions = {} as any;
	@Input('dataLabelsParams') dataLabelsParams = {} as any;
	@Input('xAxisParams') xAxisParams = {} as any;
	@Input('yAxisParams') yAxisParams = {} as any;
	@Input('grouped') grouped: boolean = false;
	@Input('data') set setData(value) {
		this.chartData = value;
		this.ngAfterViewInit();
	}

	@Input('color') set setColor(value) {
		this.color = value;
		this.ngAfterViewInit();
	}

	@Input('title') set setTitle(value) {
		this.title = value;
		this.ngAfterViewInit();
	}

	@Output('hover') hoverEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output('mouseOut') mouseOutEvent: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('container', { static: true, read: ElementRef }) container: ElementRef;

	constructor() {
	}

	ngAfterViewInit() {
		const context = this;

		this.chart = Highcharts.chart(this.container.nativeElement, {
			credits: {
				enabled: false
			},
			chart: {
				type: this.type
			},
			title: {
				text: this.show_title ? this.title : null,
				style: {
					fontFamily: 'Roboto Condensed',
					fontSize: '20px'
				}
			},
			subtitle: {
				text: this.subtitle,
				align: 'center',
				verticalAlign: 'bottom'
			},
			xAxis: {
				title: {
					text: this.x_text
				},
				type: 'category',
				uniqueNames: false,
				labels: {
					autoRotation: [-80],
					style: {
						fontSize: '13px',
						fontFamily: 'Roboto Condensed',
						color: '#000'
					}
				},
				...this.xAxisParams
			},
			yAxis: {
				title: {
					text: this.y_text
				},
				labels: {
					style: {
						fontSize: '13px',
						color: '#000',
						fontFamily: 'Roboto Condensed'
					}
				},
				...this.yAxisParams
			},
			legend: {
				enabled: false
			},
			tooltip: {
				borderColor: null,
				borderWidth: 0,
				shadow: {
					width: 3
				},
				formatter: this.formatter_function ? this.formatter_function(context) : normalColumnFormatter,
				useHTML: true,
				style: {
					fontSize: '12px',
					fontFamily: 'Roboto Condensed'
				}
			},
			plotOptions: {
				series: {
					point: {
						events: {
							mouseOver: function () {
								context.hoverEvent.emit(this);
							},
							mouseOut: function () {
								context.mouseOutEvent.emit();
							}
						}
					}
				},
				...this.plotOptions
			},
			series: this.grouped ?
				this.chartData :
				[{
					data: this.sort_data ? this.chartData.sort((a, b) => b[1] - a[1]) : this.chartData,
					type: 'column',
					color: this.color,
					dataLabels: {
						...this.dataLabelsParams
					}
				}],
			colors: this.colors
		});

		function normalColumnFormatter() {
			return this.point.name + '</br>' + '\n' + (context.tooltip_title || context.title) + ': ' + this.y;
		}

		function stackedColumnFormatter() {
			return this.series.name + ': ' + this.y;
		}
	}
}